let barEl = null;
let active = false;
let trickleTimer = null;

function ensureBar() {
  if (!barEl) {
    barEl = document.createElement('div');
    barEl.className = 'top-progress-bar';
    document.body.appendChild(barEl);
  }
}

export function startProgress(color = '#1890FF') {
  ensureBar();
  if (active) return;
  active = true;
  barEl.style.background = color;
  barEl.setAttribute('data-active', 'true');
  barEl.style.width = '0%';

  // kick off
  requestAnimationFrame(() => {
    barEl.style.width = '60%';
  });

  // trickle towards 80%
  clearInterval(trickleTimer);
  trickleTimer = setInterval(() => {
    const current = parseFloat(barEl.style.width);
    const next = Math.min(current + Math.random() * 5, 80);
    barEl.style.width = next + '%';
    if (next >= 80) clearInterval(trickleTimer);
  }, 400);
}

export function stopProgress() {
  if (!barEl || !active) return;
  clearInterval(trickleTimer);
  barEl.style.width = '100%';
  setTimeout(() => {
    barEl.setAttribute('data-active', 'false');
    barEl.style.opacity = '0';
    active = false;
    setTimeout(() => {
      if (barEl) barEl.style.width = '0%';
    }, 200);
  }, 200);
}

